<template>
  <div>
    <div class="w-full flex bg-white border-tb-12px">
      <div class="bg-f4f5f6 pb-5 border-round">
        <div class="">
          <img
            :src="showImage(selectedcard.bannerImage)"
            class="object-cover ban-he w-full border-round"
            alt="banh"
          />
        </div>
        <div class="pt-6">
          <div class="px-6">
            <div>
              <div class="flex justify-between w-full items-center">
                <h1 class="text-black font-semibold fsize20">
                  {{ selectedcard.name }}
                </h1>
                <h1
                  class="text-black font-semibold fsize20"
                  v-if="cardoptions[0].currency !== 'S$'"
                >
                  ₹{{ selectedcard.price }}
                </h1>
              </div>
              <p class="col-4f my-2">
                {{ selectedcard.description }}
              </p>
            </div>
            <div class="mt-8">
              <h4 class="fsize16 text-black font-semibold">How it works</h4>
              <div class="grid grid-cols-1 mt-4">
                <p class="col-4f fsize13 flex gap-2 mb-1 items-center">
                  <span class="greenh p-1"></span> Confirm your order & mention
                  any additional instructions as a comment.
                </p>
                <p class="col-4f fsize13 flex gap-2 mb-1 items-start">
                  <span class="greenh p-1 mt-2"></span> An expert will connect
                  with you over a 15min call to understand your requirements.
                </p>
                <p class="col-4f fsize13 flex gap-2 mb-1 items-start">
                  <span class="greenh p-1 mt-2"></span> The designs will be
                  delivered as a printable file within a week.
                </p>
                <p class="col-4f fsize13 flex gap-2 mb-1 items-start">
                  <span class="greenh p-1 mt-2"></span> Incase you want to
                  request changes to the design, you get a maximum of 3
                  iterations per collateral
                </p>
              </div>
            </div>
            <div class="mt-8" v-if="!selectedcard.isDeducted">
              <h4 class="fsize16 text-black font-semibold">Manhours</h4>
              <div class="grid grid-cols-1 mt-4">
                <p class="col-4f fsize13 flex gap-2 mb-1 items-center">
                  {{ selectedcard.manhours }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="w-5/12 pl-12 rounded-lg">
        <AddonsPayment />
      </div> -->
    </div>
  </div>
</template>
<script>
// import AddonsPayment from "../components/AddonsPayment.vue";
import { mapState } from "vuex";
export default {
  components: {
    // AddonsPayment,
  },
  computed: {
    ...mapState("studio", ["selectedcard", "cardoptions"]),
  },
  methods: {
    handleclick() {
      this.$router.push({ name: "studio-AddonsPayment" });
    },
    showImage(value) {
      let default_image = require("@/assets/images/card1.png");
      let image_base_url = process.env.VUE_APP_IMAGE_URL;
      console.log(`${image_base_url}/${value}`, "imgurl");
      return value ? `${image_base_url}/${value}` : default_image;
    },
  },
};
</script>
